import { Pipe, PipeTransform } from "@angular/core";
import { TipoOperazioneSerieDocumentaleEnum } from "@app/shared/enum/tipo-operazione-serie-documenale-enum";

@Pipe({
  name: "cleanString"
})
export class CleanStringPipe implements PipeTransform {
  transform(value: string): any {
    if (value == TipoOperazioneSerieDocumentaleEnum.AGGIUNGI_UNITA_DOCUMENTARIA.toString()) {
      return "Inserimento documento";
    } else {
      return (
        value.charAt(0).toUpperCase() +
        value
          .replace("_", " ")
          .substr(1)
          .toLowerCase()
      );
    }
  }
}
